module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "outp01"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "Outlaws with Badges display type.tif",
      "src": "Images/OutlawswithBadgesd_fmt2.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "x-1-chapter-number",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "x-2-chapter-title",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Dirty Dave Rudabaugh: The Scum of the Earth")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Dave Rudabaugh was a murderous bully, and that was on his good days. He stole and killed and brutalized people. He turned state’s evidence and sold out his friends. And, in an outlaw society not famous for painstaking personal hygiene, he was widely known for his permanent and penetrating odor.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Due to his antipathy toward honest soap and water, Rudabaugh’s smell preceded him by a quarter of an hour. Not for nothing was he known as “Dirty Dave.” He stank. He had also, as one writer put it, “the look of a man who enjoyed sleeping in his clothes,”"), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n1",
      "id": "n1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" which was putting it mildly.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Altogether, Rudabaugh was entirely without redeeming social value—a possible sociopath with psychotic overtones. In addition to his other grossly unattractive attributes, he had a vile temper. He lost his head regularly, and one day his foul disposition would cause him to lose his head literally and permanently.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Rudabaugh’s father had been killed in the Civil War, and his mother had no luck in raising him. When he grew up—as much as he ever would—Rudabaugh tried working as an express messenger, a bartender, a ranch manager, and a cowboy. One account says he pushed longhorns in the massive trail drives north from Texas to the Kansas railheads after the Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("For a while, he worked for Charlie Rath, the frontier entrepreneur of Dodge City, driving freight and hide wagons to and from the railhead. Along the way, he narrowly missed the ferocious Adobe Walls fight, having hauled a load of hides out of the buffalo-hunters’ outpost only days before a large band of Kiowas, Cheyennes, and Comanches attacked the place.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Driving wagons full of hides was not for Rudabaugh, even if he was working for popular Charlie Rath. Rudabaugh decided early that he liked money more than regular work, and in time he took up the outlaw business. He turned to rustling cattle and stealing horses and may have begun his graduate work in larceny by sticking up stages in the Black Hills. Some accounts say he also rode with an outlaw gang in Texas. Considering Rudabaugh’s nasty temperament, most of the tales of his lawless nature are probably true. However, he first appeared as a known, wanted criminal in the summer of 1877.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("In that year, the Santa Fe railroad—or maybe it was Dodge City mayor Dog Kelley—offered a Dodge lawman ten dollars a day to run down Rudabaugh and bring him in. Wyatt Earp never did find Rudabaugh on that trip, but he made a friend. Following Rudabaugh’s trail south into wild and woolly Fort Griffin, Texas, Earp met up with a consumptive, cold-eyed gambling man called Doc Holliday, sometimes dentist, most-times gambler, and shootist extraordinaire.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("As the story goes, Doc told Earp that Rudabaugh had headed for west Texas. Earp followed Rudabaugh there and elsewhere, finally returning to Fort Griffin early in 1878. There Earp discovered Rudabaugh had headed back to Kansas. So had Holliday. He and his long-time companion, Big-Nose Kate Elder—a lady who rented by the hour—had reportedly departed Fort Griffin at the high lope just ahead of a mob, after Holliday eviscerated a local hoodlum.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Early in 1878, Rudabaugh reappeared in Kansas with a bang. Before daylight on Sunday, January 27, he and four other thugs held up a train at Kinsley in one of the worst-bungled hold-ups of all time.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Rudabaugh, a hoodlum called Roarke, and several others, decided that holding up a train might make a fine payday. At first they contemplated hitting the Santa Fe train and its express car in Dodge City itself, but Roarke demurred. Tough Charlie Bassett was marshal in Dodge just then. Roarke sensibly wanted no part of Bassett’s quick and accurate Colts.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("After much quarreling, the gang settled on plan B: they would stick up the train at Kinsley, a wide spot in the road where they should meet no resistance. And so they plodded north in miserable winter weather, even abandoning the chuck wagon they had brought with them to serve the inner man. On January 26, 1878, the gang rode through light snow and piercing cold to snatch their bonanza from the railroad.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("They obviously had not planned very well. In the dead of night, on the way into town, they stopped at a railroad worker’s shack to inquire whether the train they wanted was on time. The railroad man was understandably suspicious, seeing that all his nocturnal visitors had their faces blackened. When Rudabaugh got out his revolver and began to fondle it, the railroad man got the hint. He told the gang what he could, wished them Godspeed, and went back to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("At the Kinsley depot, the gang stuck up the agent, one Kinkaid. Kinkaid, cool and tough, showed the gang an empty cash drawer, and convinced them that he couldn’t open the safe, (in which rested 2,000 good American dollars). The plucky agent was stopped in the act of taking on the whole gang with a Derringer.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("With no profit in the depot, that left the train as the next target. A citizen of Kinsley, understandably put off by the gang’s black-face disguises, ran for a gun, pursued by a bullet from Rudabaugh’s revolver. Kinkaid tried to warn the train’s engineer, but that worthy, clad in earmuffs against the wintry blasts, could hear nothing and thought the agent was simply shouting a greeting.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The train was stopped, at least. But the gang was then frustrated by a tough, resolute express messenger who answered their demands to stand and deliver with pistol bullets. At the same time, Rudabaugh was spraying slugs about indiscriminately, in the theory that if he were hostile enough, nobody would interfere.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("He was right, at least until the gang forced the crew to move the train down the line, ready for looting. At about the same time, an angry crowd of Kinsleyites came galloping up out of the snow, banging away with everything they had. After a good deal of noisy shooting—and no casualties on either side—the gang scattered, departing into the snowy night with the posse hot on their heels. The snow covered their tracks, and they won clear. They had no loot, but at least they were free.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("However, they were not free for long. Determined posses beat the bushes in all directions in spite of the wretched weather. An Army patrol from Fort Dodge got into the chase, as well. Worst of all, the gang attracted the enthusiastic attention of a formidable young lawman from Dodge City.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Kinsley was less than forty miles down the line from Dodge, out of which rode a posse led by Ford County sheriff Bat Masterson who promptly ran down Rudabaugh and one other man. Even then, at only twenty-three, Rudabaugh was said to be the veteran of “a wild career in crime,” but he was taken without a fight. When Masterson closed in on Rudabaugh and his companion, Rudabaugh started to go for his own gun. He froze in mid-reach, though, hearing the ominous “click” of posse man John Joshua Webb cocking his own weapon. “I wouldn’t do that if I was you,” said Webb pleasantly, and Rudabaugh quickly decided that Webb was right.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("During his preliminary hearing, Rudabaugh appeared “cool and collected,” according to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ford County Globe")]), _vm._v(", as he should have been since he was about to become a witness against his former comrades. As the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kinsley Graphic")]), _vm._v(" put it,")]), _vm._v(" "), _c('p', {
    staticClass: "extract extract-override-1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Rudabaugh . . . was promised entire immunity if he would “squeal,” therefore he squole. Someone said there is a kind of honor among thieves; Rudabaugh don’t think so."), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n2",
      "id": "n2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("So, as the paper said, Rudabaugh")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("“squole,” and he “squole” so convincingly that his erstwhile comrades changed their pleas to guilty. Rudabaugh then hung around town long enough to convict Roarke")]), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v(", the last survivor of this inept mob. One other gang member had chosen to shoot it out with a lawman and came in second.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("His ratting done, Rudabaugh sanctimoniously announced that he was going straight. He may even have taken semi-honest work as a deputy during the Santa Fe, Denver and Rio Grande Royal Gorge war. By late 1879, he did in fact go straight; he went straight to New Mexico where he robbed and pillaged around Las Vegas.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Rudabaugh would try anything as long as it was crooked. For a while, all went well, because Las Vegas at the time was run by as choice a collection of killers as ever walked the West. They were called the Dodge City Gang, and they mostly ran the town, at least until one of their number—the selfsame John Joshua Webb who had stopped Rudabaugh’s abortive holdup of the train—killed a rancher. Webb was arrested and jailed for murder. Rudabaugh, obviously considering Webb a valuable colleague, tried to break him out of jail, but succeeded only in killing a deputy, a solid citizen named Lino Valdez.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("With things heating up around Las Vegas, Rudabaugh headed for safer climes, though not for honest work. He headed for a hotbed of trouble, Lincoln County, New Mexico. And there, at Whiskey Jim Greathouse’s stage depot near Anton Chico, he met “Billy the Kid” McCarty, who was surely his kind of desperado. Rudabaugh quickly joined up with the Kid and the hardcases who made up the McSween army in the bloody Lincoln County War.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Rudabaugh")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("fit right in. If the Kid")]), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v(", Charlie Bowdre,")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("and Tom O’Folliard")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("were tough and mean, Rudabaugh")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("was tougher and meaner in spades, or at least meaner. According to an old friend of the Kid")]), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("’s, “If ever there was a living man the kid was afraid of, it was Rudabaugh")]), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v(".” Other old-timers said the same thing. The Kid, said one, “never dared talk to him as he did to Charles Bowdre” and the rest of his gang, thus suggesting that Rudabaugh")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("was as dangerous as he was odoriferous, even to his friends of the moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Nevertheless, Rudabaugh joined the Kid and his followers in a variety of criminal enterprises, such as running stolen horses, robbing stages, and on one occasion holding up an Army paymaster. At the end of November 1880, however, Rudabaugh, the Kid, and others were trapped by a posse at Greathouse’s stage depot, about forty miles from White Oaks, New Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Capturing the ranch cook while he was out cutting some early-morning firewood, the posse men sent that frightened minion inside with a note for the Kid telling him to surrender because they had him surrounded. Greathouse himself came out within a few moments, bringing the scribbled reply: “Go to hell,” or words to that effect. Diplomacy obviously wasn’t working.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Then, posse member Jim Carlyle, with more courage than good sense, volunteered to go inside and parley with the gang. This was not a good idea. Approachable at first—even giving Carlyle a drink—the Kid’s attitude changed when he saw Carlyle carrying a pair of his own gloves, captured earlier in the chase. The Kid turned sullen and ugly, sneering at Carlyle:")]), _vm._v(" "), _c('p', {
    staticClass: "extract extract-override-2",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("Jim, you haven’t finished your dr")]), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("i")]), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("nk. Drink up, you won’t be able to later on . . . your type should not be permitted the benefit of drawing even if you had a gun.")]), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n3",
      "id": "n3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("This all sounds somewhat high-falutin’ for the Kid, but whatever he said made Carlyle")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("understandably nervous. At two o’clock in the afternoon the time for parley expired, and one of the posse men fired a single shot to signal the end of the truce. Carlyle, perhaps expecting a general battle, bailed out of the ranch house through a window and was killed in a burst of firing. Much more shooting followed, with nobody else hit on either side; that night the outlaws got away clean.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("To this day nobody knows who really killed Carlyle")]), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v(". The Kid,")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("of course, later said that neither he nor his comrades were responsible; the posse members said the same thing. Understandably, nearly everybody blamed the outlaws. Greathouse’s building was burned down along with another ranch, and a lot of angry lawmen hit the trail, pushing hard after the Kid")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("and his cohorts.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("On December 19, Rudabaugh, the Kid, and some kindred spirits visited Fort Sumner seeking newspapers and refreshment of various kinds. Maybe they wanted current news of the posse’s actions, or maybe they just liked to see their names in print. In any case, a Pat Garrett posse ambushed the gang, killing Tom O’Folliard. Rudabaugh, his horse mortally wounded in the melee, scrambled up behind another gang member and escaped.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Garrett stayed close behind the gang, tracking his quarry through the snow in bitterly cold weather. Two days before Christmas, Garrett surrounded the remaining gang members in a small, rock building at Stinking Springs. The posse shivered through the night and at dawn permanently ventilated Charlie Bowdre when he emerged to feed his horse. Then the gang’s horses were either killed or driven off by Garrett’s men. With no food, no escape, and a dead horse jammed into the doorway of their shelter, the remaining gangmembers surrendered, returning to Las Vegas ignominiously in a guarded wagon.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Rudabaugh was about as popular as the flu in Las Vegas. Lino Valdez had been well-liked. A number of citizens believed that a tall tree and a short piece of rope were about all the due process Rudabaugh had coming. Accordingly, as a precaution, he was jailed in Santa Fe, on both the Las Vegas murder charges and a federal stage-robbing indictment. Rudabaugh was duly convicted of stage-robbing and sentenced to a term of years; he must have hoped that he’d spend the next few years in a federal prison, while the state murder charges were forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("However, it was not to be. Rudabaugh was forthwith tried for the death of Lino Valdez. Predictably, Rudabaugh passed the buck—it never stopped with him, anyway. “Little Allen did the killing,” he said and, of course, he claimed to be sinless. As he’d done before, Rudabaugh tried to dump the blame on a comrade. He claimed that he had heard a shot and turned around to see poor Valdez, down and dying. “I said to Little Allen, ‘what did you do that for?’”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("This time, however, the jury wasn’t having any and neither was the judge. The penalty was death by hanging and “May God have mercy on your soul.” The sentence would be carried out in Las Vegas. Rudabaugh’s return to his old stomping ground was not a happy one. Not only was he facing a short walk to the scaffold and a long step down, but the townspeople cordially loathed him, and he knew it. As one reporter wrote, Rudabaugh showed a restless, uneasy condition of mind:")]), _vm._v(" "), _c('p', {
    staticClass: "extract extract-override-3",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("[He] retained a stolid, hangdog demeanor and showed no disposition to recognize any of his old acquaintances . . . now the chained culprit, doomed to the decree of justice or possibly Judge Lynche’s mandate, for we hear the grumblings of men who have revenge in their hearts.")]), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n4",
      "id": "n4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("No wonder. The")]), _vm._v(" "), _c('em', {
    staticClass: "italic italic-override-1"
  }, [_vm._v("Las Vegas Optic")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-1"
  }, [_vm._v("added that Rudabaugh looked and dressed about the same as he did in Las Vegas, “apparently not having made a raid upon clothing stores.”")]), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n5",
      "id": "n5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("So, willy-nilly, shabby, stinking Rudabaugh had his reunion with John Joshua Webb, again as a resident in the San Miguel County lock-up in Las Vegas. Rudabaugh spent most of 1881 there until, in September, Rudabaugh, Webb, and three others somehow got hold of a revolver and tried to break free. They changed their minds abruptly, however, after jailer Herculano Chavez dispatched one of their number, Tom Duffy, to his reward—heavenly or otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("By early December, however, Rudabaugh was free. He, Webb, and three others managed to acquire a knife, a poker, and a pick and dug their way out, disappearing between the darkness and the dawn. Considering that the noise of somebody hammering away with a pick is a little loud even for a small-town jailer to miss, one can’t help wondering whether somebody got paid to go deaf temporarily.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Rudabaugh left the Las Vegas area in some haste, but to this day nobody is sure exactly where he went. The last months of his life, much like the early years, are forever shrouded in the shadows of time. There is, however, some evidence that he turned up in Tombstone, Arizona, drawn to trouble as usual, like iron filings to a magnet.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Down in Cochise County Rudabaugh chose the wrong side again, allying himself with the “cowboy faction”: the party of the Clantons, the McLaurys, Curly Bill Brocius, and John Ringo. By the time Rudabaugh joined up with the cowboys, the “OK Corral” fight was history and Billy Clanton and the McLaury boys were extinct, but there was still plenty of shooting to do.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("It may be that Rudabaugh was part of the savage night-time ambush of Virgil Earp. Five men attacked Virgil, and four of the attackers were identified by various witnesses. One of these witnesses was gang member Indian Joe, who gave his information just before Wyatt Earp shot him full of holes. But nobody seemed to know who the fifth attacker was. He was “new around the mining camp,” and nobody could, or would, give him a name. Virgil Earp was shot down on December 28, 1881. Rudabaugh had broken out of jail in Las Vegas twenty-five days earlier, so he would have had plenty of time to ride south and look for more trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("On the other hand, many years later Wells Fargo agent Fred Dodge said cowboy adherent Johnny Barnes confessed that he had been the fifth man in the group who gunned down Virgil Earp in the dark. Barnes, a more likely choice to have been in the band that attacked Virgil Earp, had been a member of the Clanton bunch for quite some time. Rudabaugh would have been a newcomer. Still, Barnes would not have been “new around the mining camp.” If the other witnesses are to be believed, the fifth attacker could not have been Barnes.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Whether he was involved in the attack on Virgil Earp or not, Rudabaugh may well have been a cowboy gunman by the following spring. In the famous fight at Iron Springs, Wyatt Earp reportedly recognized Rudabaugh as one of the ambushers. In May 1882, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ford County Globe")]), _vm._v(" told of the Iron Springs fight:")]), _vm._v(" "), _c('p', {
    staticClass: "extract extract-override-1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Wyatt and Warren Earp arrived some days ago and will remain awhile. . . . Wyatt says after the first shock he could distinguish David Rudabaugh and Curly Bill, the latter’s body showing well among the bushes."), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n6",
      "id": "n6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Wyatt Earp would surely have recognized Rudabaugh from the Dodge City days, and there is no reason for him to allege falsely that Rudabaugh was at Iron Springs if he was not.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("However, in Stuart Lake’s biography of Wyatt Earp, the only biography for which Wyatt Earp actually provided information, Rudabaugh is not mentioned as a cowboy partisan. Describing the Iron Springs fight all those decades before, Wyatt Earp was very clear and very specific, at least as Lake quoted him:")]), _vm._v(" "), _c('p', {
    staticClass: "extract extract-override-1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("From the instant I laid eyes on Curly Bill, I was seeing and thinking clearly. Nothing that went on in that gully escaped me, although what happened in a very few seconds takes much longer to tell. . . . I recognized Pony Deal, and as seven others broke for the cottonwoods, I named each one as he ran, saying to myself, “I’ve got a warrant for him.”"), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n7",
      "id": "n7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Earp named all of the seven to Lake, but Rudabaugh was not among them.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("There is no way to determine which account is accurate—the tale as related by Lake, or the quote from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Globe")]), _vm._v("—or for that matter, whether either one of them is. If one assumes Earp actually gave both versions, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Globe’s")]), _vm._v(" story is more probable because it was written when Earp was in his prime and had no motive to embroider a story of the fight. Lake’s interviews with Earp were conducted more than forty years later, when the old lawman was coming to the end of the trail, and when, perhaps, he thought he might turn a dollar on the story of his life.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Regardless of who ambushed Earp, Doc Holliday, and the others at Iron Springs, Curly Bill all but certainly died there, chock full of shot from Earp’s shotgun. Rudabaugh, if he was part of the fight, escaped. After Curly Bill went down, and after Earp and his friends killed several more of the cowboy gang, the survivors—presumably including Rudabaugh—lost a good deal of their interest in Arizona generally and Tombstone specifically.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Mexico looked far more promising—and a whole lot healthier. Rudabaugh made his way south of the border and stayed there. At this point the mist gets thicker. Nobody is really sure how Rudabaugh finished his earthly course. One story has him marrying and settling down. He may have turned up, a broken man, more than thirty years later in Deer Lodge, Montana. A man named Dave Rudabaugh did indeed appear in Deer Lodge—at least that’s who he said he was. The trail ends there, unconfirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("But the most common story about Rudabaugh’s last days puts him in Mexico, south of the Arizona line in Chihuahua. It is a very good tale indeed, and almost certainly true—hopefully, if only for the poetic justice of its ending. Here’s how it goes.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("What Rudabaugh was doing in Chihuahua is not entirely clear. Maybe he had moved his robbing business south of the border; maybe he was simply hiding from the American law; maybe the living was just easier in Old Mexico; or maybe, according to one entertaining tale, Rudabaugh was actually working.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("This story recounts that Rudabaugh had repeatedly robbed payrolls belonging to the local cattle-king, Terrazas (sometimes Terrasas), governor of Chihuahua. Terrazas was a big operator, big enough that during the Spanish-American War, Chicago meat packers wired him to ask whether he could supply them with 50,000 head of cattle. Terrazas is said to have wired back only, “what color?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Maybe. Whether the story of the telegram is true or not, Terrazas was certainly an important man. He may have employed Rudabaugh to protect his herds on the reasonable thesis that it’s better to hire the fox to guard the hen house than to worry about where the varmint is and what he’s up to. Perhaps, as another version of the story has it, after being hired to run one of Terrazas’ ranches, Rudabaugh stole from his boss and was fired as a result. Rudabaugh, of course, resented being fired, which didn’t improve his naturally ugly disposition.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Whatever the reason, Rudabaugh hung out in the town of Parral, taking out his resentment on the inhabitants by making life generally miserable for them. To Rudabaugh, the local citizens were all “greasers,” a sort of subhuman helot or serf who could be shot, beaten, and shoved out of the way at will. The locals didn’t like Rudabaugh much either.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Things came to a head—literally—on February 18, 1886. Nobody knows precisely what happened in Parral, but this much is reasonably certain: Rudabaugh was being his customary, ugly self in a local cantina. According to one account, he pushed aside several Mexican patrons, ordered a bottle of tequila, and spat part of it on the floor."), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n8",
      "id": "n8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("After this warm-up, Rudabaugh proceeded to play poker with some of the locals. Upset at losing and screaming that he’d been cheated, Rudabaugh quickly sought to change his luck by killing two of the players and wounding another. He then, after spraying enough bullets around to clear the cantina, took his leave. One story says that he couldn’t find his horse and, therefore, went back inside the cantina.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("This was no ordinary night in Parral. The citizenry had had enough of this blustering bully, and a bunch of them ambushed Rudabaugh in the street outside the cantina—or possibly inside the place when Rudabaugh re-entered. This time there were no other hoodlums to help him, no excuses to make, no lies to tell, nobody to rat on, and no place to run.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Thus was the end of Dirty Dave Rudabaugh, full of holes in a town that hated his guts, mourned by absolutely nobody. Well known and generally detested throughout the southwest, Rudabaugh’s demise was widely reported in Arizona and New Mexico newspapers, such as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Las Vegas Optic.")]), _vm._v(" There was no hint of regret for his passing.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Like the Bard’s Thane of Cawdor, nothing in Rudabaugh’s life became him like the leaving of it—for he gave the good citizens of Parral reason to celebrate. And they did so, exuberantly. “The natives of Parral got a procession in honor of the event,” as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tombstone Democrat")]), _vm._v(" put it.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("They declared a fiesta and commemorated their tormentor’s demise by cutting off Rudabaugh’s ugly head—scruffy mustache, hat, and all—impaling it on a pole, and parading it in celebration around and about the plaza of the town. An American photographer even captured a picture of a citizen solemnly holding Rudabaugh’s head on a platter—still complete with hat—a little reminiscent of Salome, but with a droopy mustache, holding the head of John the Baptist.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "Oklahoma544_300.jpg",
      "src": "Images/Oklahoma544_300_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "generated-style"
  }, [_c('img', {
    attrs: {
      "alt": "Oklahoma545_300.jpg",
      "src": "Images/Oklahoma545_300_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "generated-style-2"
  }, [_c('p', {
    staticClass: "captions",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dave Rudabaugh’s head after his death")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override-8"
  }, [_vm._v("(Western History Collections, University of Oklahoma Libraries)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Las Vegas Optic")]), _vm._v(" summed up Rudabaugh’s repulsive nature pretty well:")]), _vm._v(" "), _c('p', {
    staticClass: "extract extract-override-1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Dave Rudabaugh, who was recently killed at Parral, in the state of Chihuahua, Mexico, was what might be called an “all around desperado.” He was equally proficient in holding up a railroad train or a stage coach or, as occasion offered, robbing a bank, “shooting up” a frontier settlement, or running off stock. He indulged in these little peculiarities for a year or two in Arizona."), _c('span', {
    staticClass: "note",
    attrs: {
      "href": "#/Text/notes#c1n9",
      "id": "n9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Had anybody put up a headstone for Rudabaugh, which nobody did, it might have read something like this: “Good riddance.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e8cb3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/outP01.vue
// module id = 78
// module chunks = 0